module.exports = __webpack_public_path__ + "static/media/success.037429ca.svg";